import { messageFragment } from '@/services/fragments'

export const messagesByReviewQuery = /* GraphQL */ `
  query MessagesByReview(
    $reviewID: ID!
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMessageByReviewIDAndCreatedAt(
      reviewID: $reviewID
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        message
        status
        user {
          id
          name
        }
        userID
        mentions(limit: 50) {
          items {
            userMentionsId
          }
          nextToken
        }
      }
      nextToken
    }
  }
`

export const reviewMessageMentionsQuery = /* GraphQL */ `
  query ReviewMessageMentions($id: ID!, $limit: Int, $nextToken: String) {
    getMessage(id: $id) {
      mentions(limit: $limit, nextToken: $nextToken) {
        items {
          userMentionsId
        }
        nextToken
      }
    }
  }
`

export const createReviewMessageMutation = /* GraphQL */ `
  mutation CreateReviewMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      createdAt
    }
  }
`

export const updateReviewMessageMutation = /* GraphQL */ `
  mutation UpdateReviewMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      updatedAt
    }
  }
`

export const createMessageMutation = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      createdAt
    }
  }
`

export const updateMessageMutation = /* GraphQL */ `
  mutation UpdateMessage($input: UpdateMessageInput!) {
    updateMessage(input: $input) {
      updatedAt
    }
  }
`

export const messagesByOrderQuery = /* GraphQL */ `
  query MessagesByOrder(
    $orderID: ID!
    $limit: Int
    $nextToken: String
    $filter: ModelMessageFilterInput
  ) {
    messagesByOrder(
      orderID: $orderID
      limit: $limit
      nextToken: $nextToken
      filter: $filter
      sortDirection: DESC
    ) {
      items {
        ...message
      }
      nextToken
    }
  }
  ${messageFragment}
`

export const messagesByToUser = /* GraphQL */ `
  query messagesByToUser(
    $toUserID: ID!
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByToUser(
      toUserID: $toUserID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...message
      }
      nextToken
    }
  }
  ${messageFragment}
`

export const onCreateMessageQuery = /* GraphQL */ `
  subscription onCreateMessage($toUserID: ID!) {
    onCreateMessage(filter: { toUserID: { eq: $toUserID } }) {
      ...message
    }
  }
  ${messageFragment}
`
